module.exports = __webpack_public_path__ + "static/media/button_down_clicked.62bb6c9c.svg";